import * as React from 'react'

function SvgFunArrowMiniUp(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 10a.475.475 0 01.353.163l3.5 3.889a.6.6 0 010 .785.465.465 0 01-.707 0L12 11.341l-3.146 3.496a.465.465 0 01-.707 0 .6.6 0 010-.785l3.5-3.89A.475.475 0 0112 10" />
    </svg>
  )
}

export default SvgFunArrowMiniUp
